<template>
    <div class="pd20">
        <div class="main">
            <!-- list -->
            <div class="list-box">
                <el-table  :data="list" show-overflow-tooltip border style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="80" label="序号"></el-table-column>
                    <el-table-column  label="题目">
                        <template  slot-scope="scope">
                            <!-- 判断是否编辑当前行下边的数据 -->
                            <input v-if="(list_index== scope.$index) && table_edit_show" type="text"  class="question" v-model="scope.row.name" />
                            <div v-else>{{scope.row.name}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  label="类型">
                        <template  slot-scope="scope">
                            <!-- 判断是否编辑当前行下边的数据 -->
                            <el-select v-if="(list_index== scope.$index) && table_edit_show" v-model="scope.row.type" clearable  @change="typeChangeHandle" placeholder="请选择">
                                <el-option label="文字" value="0">文字</el-option>
                                <el-option label="单选" value="1">单选</el-option>
                            </el-select>
                            <div v-else>{{scope.row.type==0?'文字':scope.row.type==1?'单选':''}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  label="选项">
                        <template slot-scope="scope">
                            <!-- 判断是否编辑当前行下边的数据,type_no_radio是判断他是否选择的是单选 -->
                            <input readonly v-if="(list_index== scope.$index) && table_edit_show && type_no_radio" type="text" @focus="answerFocusHandle(scope.row.answer)"   class="question" v-model="scope.row.answer" />
                            <div v-else>{{scope.row.answer}}</div>
                            <!-- 显示常用选项表格 -->
                            <el-tag class="commonly-used" v-if="(list_index== scope.$index) && table_edit_show && type_no_radio" @click="commonly_used_dialog = true" size="small">常用</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column  label="分组">
                        <template slot-scope="scope">
                            <!-- 判断是否编辑当前行下边的数据,type_no_radio是判断他是否选择的是单选 -->
                            <el-select v-if="(list_index== scope.$index) && table_edit_show && type_no_radio" v-model="scope.row.did" clearable   placeholder="请选择">
                                <el-option v-for="(item,index) in dimensions_list" :key="index" :label="item.name" :value="item.id">{{item.name+' ('+item.mark+')'}}</el-option>
                            </el-select>
                            <div v-else v-for="(item,index) in dimensions_list" :key="index">{{item.id== scope.row.did?item.name:''}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  label="操作" width="200">
                        <template  slot-scope="scope">
                            <el-button icon="el-icon-top" size="mini" @click="scoreTopHandle(scope.$index, scope.row)" circle></el-button>
                            <el-button icon="el-icon-bottom" size="mini"  @click="scoreBottomHandle(scope.$index, scope.row)" circle></el-button>
                            <el-button type="primary" v-if="(list_index== scope.$index) && table_edit_show" size="mini" icon="el-icon-check" @click="table_edit_show = false"  circle></el-button>
                            <el-button type="primary" v-else size="mini" icon="el-icon-edit" @click="tableDbEdit(scope.$index, scope.row,$event)"  circle></el-button>
                            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteRow(scope.$index, scope.row)"  circle></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 添加按钮 -->
            <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus" @click="addRow"  circle></el-button>
            <el-button type="primary" class="addBtn saveBtn" size="mini" icon="el-icon-circle-check" @click="submitHandle">保存更改</el-button>
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
            <!--  -->
            <!-- <div class="pages-box"></div> -->
        </div>
        <!-- 选项编辑 -->
        <el-dialog title="请填写" class="elDialog"  :visible.sync="dialogTableVisible">
            <el-table :data="popoverData" show-overflow-tooltip border style="width: 100%">
                <el-table-column label="选项">
                    <template slot-scope="scope" >
                        <input v-if="(answer_index == scope.$index) && popoverInputShow" type="text" placeholder="请输入选项名" v-model="scope.row.options"  />
                        <div v-else>{{scope.row.options}}</div>
                    </template>
                </el-table-column>
                <el-table-column width="200"   label="分数">
                    <template slot-scope="scope"  >
                        <input v-if="(answer_index == scope.$index) && popoverInputShow" type="text" placeholder="请输入分数"  v-model="scope.row.score"  />
                        <div v-else>{{scope.row.score}}</div>
                    </template>
                </el-table-column>
                <el-table-column width="100"  label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" v-if="(answer_index == scope.$index) && popoverInputShow" size="mini" icon="el-icon-check" @click="saveAnswerEdit(scope.$index, scope.row,$event)"  circle></el-button>
                        <el-button type="primary" v-else size="mini" icon="el-icon-edit" @click="answerEdit(scope.$index, scope.row,$event)"  circle></el-button>
                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="answerDelete(scope.$index,scope.row)"  circle></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--  -->
            <div slot="footer" class="dialog-footer">
                <el-button size="small" class="addRow" icon="el-icon-circle-plus" @click="addAnswerHandle" type="info"></el-button>
                <el-button size="small"  @click="dialogTableVisible =false" >取消</el-button>
                <el-button type="primary" size="small " @click="answerSubmitHandle">确定</el-button>
            </div>
        </el-dialog>
        <!-- 配置常用选项 -->
        <el-dialog  class="elDialog"  :visible.sync="commonly_used_dialog">
            <el-table :data="commonly_used_data" show-overflow-tooltip border style="width: 100%">
                <el-table-column type="index" width="100" label="序号"></el-table-column>
                <el-table-column    label="常用选项">
                    <template slot-scope="scope"  >
                        <input v-if="(commonly_used_index == scope.$index) && commonly_used_show" type="text" placeholder="请输入常用选项(格式：姓名:张三;)"  v-model="scope.row.content"  />
                        <div v-else>{{scope.row.content}}</div>
                    </template>
                </el-table-column>
                <el-table-column width="150"  label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" v-if="(commonly_used_index == scope.$index) && commonly_used_show" size="mini" icon="el-icon-check" @click="saveCommonlyEdit(scope.$index, scope.row,$event)"  circle></el-button>
                        <el-button type="primary" v-else size="mini" icon="el-icon-edit" @click="commonlyEdit(scope.$index, scope.row,$event)"  circle></el-button>
                        <el-button type="primary" v-if="!commonly_used_show" size="mini" icon="el-icon-check" @click="saveCommonlyEdit(scope.$index, scope.row,$event)"  circle></el-button>
                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="commonlyDelete(scope.$index, scope.row,commonly_used_data)"  circle></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--  -->
            <div slot="footer" class="dialog-footer">
                <el-button size="small" class="addRow" icon="el-icon-circle-plus" @click="commonly_used_data.push({content:''})" type="info"></el-button>
                <el-button size="small"  @click="closeCommonly" >取消</el-button>
                <el-button type="primary" size="small " @click="commonlySubmitHandle">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { questionList,questionAdd,questionDel,questionConfig,questionConfigDel } from "@/api/measurement";
export default {
    data() {
        return{
            list: [],
            pages: {},
            // 
            dimensions_list:[],
            // 判断点击的是哪行
            list_index:null,
            table_edit_show:false,
            type_no_radio:true,
            // 选项表格
            popoverData:[],
            dialogTableVisible:false,
            // 隐藏弹出表格里边的输入框
            popoverInputShow:true,
            // 存储选项的字符串
            answer_str:'',
            answer_index:null,
            // 配置常用选项
            commonly_used_dialog:false,
            commonly_used_data:[],
            commonly_used_index:null,
            commonly_used_show:false
        }
    },
    props:['eid'],
    methods:{
        commonlyDelete(index,rows,list){
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(rows.id){
                    questionConfigDel({id:rows.id}).then((data)=>{
                        if(data.error >0){
                            this.$message(data.msg);
                            return
                        }
                        this.$message({
                            message: '删除成功！',
                            type: 'success'
                        });
                    });
                }
                this.commonly_used_show = false;
                // 删除数组内容的数据
                this.commonly_used_data.splice(index, 1);
            }).catch();
        },
        commonlySubmitHandle(){
            let obj = {
                list:this.commonly_used_data
            };
            this.commonly_used_show = false;
            this.commonly_used_dialog =false; 
            questionConfig(obj).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return
                }
                this.$notify({
                    title: '成功',
                    message: '保存成功',
                    type: 'success'
                });
            });
        },
        saveCommonlyEdit(index,rows){
            this.commonly_used_show=false;
            this.list[this.list_index].answer = rows.content;
            this.commonly_used_dialog =false; 
        },
        closeCommonly(){
            this.commonly_used_show=false;
            this.commonly_used_dialog =false; 
        },
        // 常用选项编辑
        commonlyEdit(index,rows){
            this.commonly_used_index = index;
             this.commonly_used_show = true;
        },
        // 上移
        scoreTopHandle(index,row){
            if(row.sort >1){
                // ES6解构赋值交换数组元素位置
                [this.list[index].sort,this.list[index-1].sort] = [this.list[index-1].sort,this.list[index].sort];

                let obj1 = this.list[index];
                let obj2 = this.list[index - 1];

                this.$set(this.list, index, obj2);
                this.$set(this.list, index - 1, obj1);

            }else{
                this.$message('已经是最上边了！');
            }
        },
        // 下移
        scoreBottomHandle(index,row){
            if(row.sort <this.list[this.list.length-1].sort){
                // ES6解构赋值交换数组元素位置
                [this.list[index].sort,this.list[index+1].sort] = [this.list[index+1].sort,this.list[index].sort];
                
                let obj1 = this.list[index];
                let obj2 = this.list[index + 1];

                this.$set(this.list, index, obj2);
                this.$set(this.list, index + 1, obj1);
            }else{
                this.$message('已经是最下边了！');
            }
        },
        // 隐藏可编辑的文本框
        saveAnswerEdit(index,row,event){
            this.answer_index = index;
            this.popoverInputShow = false;
        },
        // 显示可编辑的文本框
        answerEdit(index,row,event){
            this.popoverInputShow=true;
            this.answer_index = index;
        },
        // 添加一行选项
        addAnswerHandle(){
            //表格新增一行，其实就是源数据的新增
            this.popoverData.push({ options:'',score:null});
        },
        // 选项点击确定，把数据显示在表格的选项一列里
        answerSubmitHandle(){
            let str = '';
            for(let i=0;i<this.popoverData.length;i++){
                if(this.popoverData[i].options && this.popoverData[i].score){
                    str += this.popoverData[i].options+':'+this.popoverData[i].score+';';
                }
            }
            this.list[this.list_index].answer = str;
            // 隐藏可编辑的输入框
            this.popoverInputShow = false;
            // 隐藏弹出的dialog
            this.dialogTableVisible = false;
        },
        // 选项获得焦点
        answerFocusHandle(val){
            if(!val){
                this.popoverData = [];
            }else{
                let arr1 = val.split(';');
                let list = [];
                for(let item of arr1){
                    if(item){
                        list.push({
                            options:item.split(':')[0],
                            score:item.split(':')[1]
                        })
                    }
                }
                this.popoverData = list;
            }
            
            this.dialogTableVisible = true;
        },
        // 删除选项配置
        answerDelete(index, rows){
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除数组内容的数据
                this.popoverData.splice(index, 1);
            }).catch();
        },
        // 类型改变时
        typeChangeHandle(val){
            this.type_no_radio = val==0?false:true;
            if(!this.type_no_radio){
                this.list[this.list_index].answer = '';
                this.list[this.list_index].did = '';
            }
        },
        pullData(){
            this.$showLoading();
            questionList({
                eid:this.$route.query.id,
                page:this.pages?this.pages.page:null,  //页码，默认1
                size:this.pages?this.pages.size:null,   //每页数量，默认25
            }).then((data)=>{
                this.dimensions_list = data.dimensions;
                this.list = data.list;
                this.pages = data.pager;
                this.commonly_used_data= data.question_config;
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        },
        // 删除一行
        deleteRow(index, rows) {
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                questionDel({
                    id:rows.id
                }).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return
                    }
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success'
                    });
                    this.pullData();
                });

                //移除一行,删掉该行
                rows.splice(index, 1);
            }).catch();
        },
        addRow(){
            //表格新增一行，其实就是源数据的新增
            this.list.push({ eid:this.$route.query.id,did:'',name: '',type:'1',answer:'',sort:this.list.length+1});
        },
        // 显示输入框
        tableDbEdit(index,row,event) {
            this.list_index = index;
            // 把类型转换为字符串
            this.list[index].type = row.type+'';
            this.table_edit_show = true;
        },
        submitHandle(){

            let obj = {
                list:this.list
            };
            this.$confirm('是否确认保存?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                questionAdd(obj).then((data)=>{
                    this.$notify({
                        title: '成功',
                        message: '保存成功',
                        type: 'success'
                    });
                    this.pullData();
                });
            }).catch();
        },
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.addBtn.saveBtn{
    left: 30px;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.dialog-footer{
    text-align: right;
    margin-top: 10px;
    .addRow{
        margin-right: 15px;
    }
}
</style>
<style lang="scss">
  .list-box table{
    input.question{
        background-color: #ffffff !important;
        color: #fe893c !important;
        padding: 5px 8px;
        margin-left: 10px;
        border-radius: 5px;
        width: 60%;
    }
    .commonly-used{
        margin-left: 8px;
    }
  }
  .elDialog {
      input{
        width: 70%;
        background-color: #ffffff !important;
        color: #333333 !important;
        border-radius: 5px;
        padding: 5px 8px;
      }
  }
</style>
